module.exports = __webpack_public_path__ + "static/media/BIO-NEW.28228df7.apng";